import React from "react";
import {Loader} from "../../components/Loader";
import {ListComponent} from "../../components/ListComponent";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {Util} from "../../components/Util";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {DateTime} from "../../components/ListComponent/DateTime";
import {Dictionary} from "../../components/Dictionary";
import Info from "../../components/FormComponent/FormGroup/Info";

export class MissingStorage extends ListComponent {
    private item: any = null;

    protected getRequestUrl(): RequestInfo | URL {
        return '/storage/missing-storage';
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const params: {} | any = this.getFormData(), dictionary: Dictionary = this.dictionary;
        this.state?.item && (this.item = this.state?.item);

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>
                            <div className="col-12 col-lg-9">
                                <Info>
                                    {this.dictionary.get['missing-storage-info']}
                                </Info>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'product_id', defaultValue: params?.product_id}}/>
                            </div>

                            <div className="col-lg-3 col-md-4">
                                <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'id.created_at:d'}/>
                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/storage/missing-storage-export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['missing-storage']}: &nbsp;
                                    <strong>{this.state.count ? this.state.count : '-'}</strong> {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th style={{textAlign: 'right'}}>
                                    {this.dictionary.get['missing-products']}
                                </th>
                                <th className="sortable" data-sortkey="i.product_id" style={{textAlign: 'right'}}>
                                    {this.dictionary.get['product_id']}
                                </th>
                                <th className="sortable"
                                    data-sortkey="p.`name`">{this.dictionary.get['product_name']}</th>
                                <th className="sortable" data-sortkey="i.`sku`" style={{textAlign: 'right'}}>
                                    {this.dictionary.get['sku']}
                                </th>
                                <th className="sortable"
                                    data-sortkey="i.`missing_quantity`"
                                    style={{textAlign: 'right'}}>
                                    {this.dictionary.get['missing_quantity']}
                                </th>
                                <th className="sortable" data-sortkey="i.created_at">
                                    {this.dictionary.get['sync_at']}
                                </th>
                                <th className="sortable" data-sortkey="id.created_at">
                                    {this.dictionary.get['updated_at']}
                                    <i className="bi bi bi-sort-down"></i>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                return (
                                    <tr key={elem.product_id} data-id={elem.product_id}>
                                        <td style={{textAlign: 'right'}}>
                                            {Util.link(dictionary.get['details'] + ' (' + elem.eventCount + ')', '/product/missing#product_id=' + elem.product_id)}
                                        </td>
                                        <td style={{textAlign: 'right'}}>
                                            {Util.link(elem.product_id, '/product/details/' + elem.product_id)}
                                        </td>
                                        <td>{elem.product_name}</td>
                                        {Util.searchCell(elem.sku, 'sku', {style: {textAlign: 'right'}})}
                                        <FormattedNumber value={elem.missing_quantity}
                                                         parentNode="td" suffix={dictionary.get['pc']}
                                                         style={{textAlign: 'right'}}/>
                                        <td><DateTime value={elem.created_at} inline={true}/></td>
                                        <td><DateTime value={elem.lastUpdate} inline={true}/></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={8}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        )
            ;
    }
}
